export default {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:1337',
  siteUrl: process.env.REACT_APP_SITE_URL || 'http://qbm.devls',
}